import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const POST_PAYROLL_EMPLOYEE_REQUEST = "POST_PAYROLL_EMPLOYEE_REQUEST";
export const POST_PAYROLL_EMPLOYEE_SUCCESS = "POST_PAYROLL_EMPLOYEE_SUCCESS";
export const POST_PAYROLL_EMPLOYEE_ERROR = "POST_PAYROLL_EMPLOYEE_ERROR";

//* ACTIONS ------------------------------------------------
export const postPayrollEmployeeRequest = (payload = {}, callback) => ({
  type: POST_PAYROLL_EMPLOYEE_REQUEST,
  payload,
  callback,
});

export const postPayrollEmployeeSuccess = () => ({
  type: POST_PAYROLL_EMPLOYEE_SUCCESS,
});

export const postPayrollEmployeeError = (error) => ({
  type: POST_PAYROLL_EMPLOYEE_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const postPayrollEmployeeServiceRequest = async ({
  payrollId,
  employeeId,
  ...data
}) => {
  const options = await withToken({
    method: Methods.POST,
    headers: { CompanyId: await getUserCompany() },
    data,
  });

  return request(`/payrolls/${payrollId}/employees/${employeeId}`, options);
};
